import React, { createContext, useContext } from "react";
import { SpaceController } from "../../features/virtual-space/useSpacePlayerController";

export type VirtualSpaceContextType = {
    spaceController: SpaceController;
};
export const VirtualSpaceContext: React.Context<VirtualSpaceContextType | undefined> = createContext<
    VirtualSpaceContextType | undefined
>(undefined);

export const useVirtualSpaceContext = () => {
    const context = useContext(VirtualSpaceContext);
    if (context == null) {
        throw new Error("Missing VirtualSpaceContext");
    }
    return context;
};
